<footer class="c-sitefooter">
  <div class="l-container">

    <div class="l-grid">
      <div class="l-grid__unit  l-grid__unit--8of12@medium">

        <p class="c-footer-copyright  u-margin-bottom-none@medium">&copy; {{'FOOTER.copyright_details' | translate}} </p>

      </div>
      <div class="l-grid__unit  l-grid__unit--4of12@medium">
        <nav>
          <ul class="c-footernav">
            <li class="c-footernav__item"><a class="c-footernav__link" href="{{'FOOTER.privacy_url' | translate}}" target="_blank">{{'FOOTER.privacy' | translate}}</a></li>
            <li class="c-footernav__item"><a class="c-footernav__link" href="{{'FOOTER.disclaimer_url' | translate}}" target="_blank">{{'FOOTER.disclaimer' | translate}}</a></li>
            <li class="c-footernav__item"><a class="c-footernav__link" href="{{'FOOTER.cookies_url' | translate}}" target="_blank">{{'FOOTER.cookies' | translate}}</a></li>
          </ul>
        </nav>
      </div>
    </div>

  </div>
</footer>
